<template>
  <div class="lotery_hit_egg_container">
    <div class="home_btn" @click="backHome">
      <img src="../assets/defult/img/closebtn.png" alt="" srcset="">
    </div>

    <div class="title">
      <img :src="defultLotteryTitle" alt="" srcset="" />
    </div>

    <div class="egg_blue egg" @click="breakegg('b')">
      <img src="../assets/defult/img/blueegg.png" />
    </div>
    <div class="egg_green egg" @click="breakegg('g')">
      <img src="../assets/defult/img/greenegg.png" />
    </div>
    <div class="egg_red egg" @click="breakegg('r')">
      <img src="../assets/defult/img/redegg.png" />
    </div>

    <div class="dialog" v-show="showBreakEggAnimate">
      <div class="dialog_content_hit_egg">
        <!-- <img :src="breakEggImgList[aniIndex]" class="animat_imgs" /> -->
        <template v-for="n in eggb_ani.length" >
          <img :src="eggb_ani[n]" class="animat_imgs" :key="n" v-show="n == aniIndex && eggShowType == 'b'" />
          <img :src="eggg_ani[n]" class="animat_imgs" :key="n" v-show="n == aniIndex && eggShowType == 'g'" />
          <img :src="eggr_ani[n]" class="animat_imgs" :key="n" v-show="n == aniIndex && eggShowType == 'r'" />
        </template>

      </div>
    </div>

    <div class="dialog" v-if="showModalTrigger">
      <div class="dialog_content">
        <div class="dialog_alert" :style="{ backgroundImage: defultWinningDialog }">
          <div class="text">
            {{ msg }}<br />
            {{ msg2 }}<br />
          </div>
          <span style="font-size: 16px;color: #066E30;text-align:center;">{{ $t("turn.count") }}：{{ memberCount }}</span><br />
        </div>
        <div class="close_btn">
          <img :src="defultWinningDialogButton" @click="showModalTrigger = !showModalTrigger" style="width: 120px">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/defult/css/hitegg.css";
import b01png from "../assets/defult/img/eggs/b/egg_b_01.png";
import b02png from "../assets/defult/img/eggs/b/egg_b_02.png";
import b03png from "../assets/defult/img/eggs/b/egg_b_03.png";
import b04png from "../assets/defult/img/eggs/b/egg_b_04.png";
import b05png from "../assets/defult/img/eggs/b/egg_b_05.png";
import b06png from "../assets/defult/img/eggs/b/egg_b_06.png";
import b07png from "../assets/defult/img/eggs/b/egg_b_07.png";
import b08png from "../assets/defult/img/eggs/b/egg_b_08.png";
import b09png from "../assets/defult/img/eggs/b/egg_b_09.png";
import b10png from "../assets/defult/img/eggs/b/egg_b_10.png";
import b11png from "../assets/defult/img/eggs/b/egg_b_11.png";
import b12png from "../assets/defult/img/eggs/b/egg_b_12.png";
import b13png from "../assets/defult/img/eggs/b/egg_b_13.png";
import b14png from "../assets/defult/img/eggs/b/egg_b_14.png";
import b15png from "../assets/defult/img/eggs/b/egg_b_15.png";
import b16png from "../assets/defult/img/eggs/b/egg_b_16.png";
import b17png from "../assets/defult/img/eggs/b/egg_b_17.png";
import b18png from "../assets/defult/img/eggs/b/egg_b_18.png";
import b19png from "../assets/defult/img/eggs/b/egg_b_19.png";
import b20png from "../assets/defult/img/eggs/b/egg_b_20.png";
import b21png from "../assets/defult/img/eggs/b/egg_b_21.png";
import b22png from "../assets/defult/img/eggs/b/egg_b_22.png";

import g01png from "../assets/defult/img/eggs/g/egg_g_01.png";
import g02png from "../assets/defult/img/eggs/g/egg_g_02.png";
import g03png from "../assets/defult/img/eggs/g/egg_g_03.png";
import g04png from "../assets/defult/img/eggs/g/egg_g_04.png";
import g05png from "../assets/defult/img/eggs/g/egg_g_05.png";
import g06png from "../assets/defult/img/eggs/g/egg_g_06.png";
import g07png from "../assets/defult/img/eggs/g/egg_g_07.png";
import g08png from "../assets/defult/img/eggs/g/egg_g_08.png";
import g09png from "../assets/defult/img/eggs/g/egg_g_09.png";
import g10png from "../assets/defult/img/eggs/g/egg_g_10.png";
import g11png from "../assets/defult/img/eggs/g/egg_g_11.png";
import g12png from "../assets/defult/img/eggs/g/egg_g_12.png";
import g13png from "../assets/defult/img/eggs/g/egg_g_13.png";
import g14png from "../assets/defult/img/eggs/g/egg_g_14.png";
import g15png from "../assets/defult/img/eggs/g/egg_g_15.png";
import g16png from "../assets/defult/img/eggs/g/egg_g_16.png";
import g17png from "../assets/defult/img/eggs/g/egg_g_17.png";
import g18png from "../assets/defult/img/eggs/g/egg_g_18.png";
import g19png from "../assets/defult/img/eggs/g/egg_g_19.png";
import g20png from "../assets/defult/img/eggs/g/egg_g_20.png";
import g21png from "../assets/defult/img/eggs/g/egg_g_21.png";
import g22png from "../assets/defult/img/eggs/g/egg_g_22.png";

import r01png from "../assets/defult/img/eggs/r/egg_r_01.png";
import r02png from "../assets/defult/img/eggs/r/egg_r_02.png";
import r03png from "../assets/defult/img/eggs/r/egg_r_03.png";
import r04png from "../assets/defult/img/eggs/r/egg_r_04.png";
import r05png from "../assets/defult/img/eggs/r/egg_r_05.png";
import r06png from "../assets/defult/img/eggs/r/egg_r_06.png";
import r07png from "../assets/defult/img/eggs/r/egg_r_07.png";
import r08png from "../assets/defult/img/eggs/r/egg_r_08.png";
import r09png from "../assets/defult/img/eggs/r/egg_r_09.png";
import r10png from "../assets/defult/img/eggs/r/egg_r_10.png";
import r11png from "../assets/defult/img/eggs/r/egg_r_11.png";
import r12png from "../assets/defult/img/eggs/r/egg_r_12.png";
import r13png from "../assets/defult/img/eggs/r/egg_r_13.png";
import r14png from "../assets/defult/img/eggs/r/egg_r_14.png";
import r15png from "../assets/defult/img/eggs/r/egg_r_15.png";
import r16png from "../assets/defult/img/eggs/r/egg_r_16.png";
import r17png from "../assets/defult/img/eggs/r/egg_r_17.png";
import r18png from "../assets/defult/img/eggs/r/egg_r_18.png";
import r19png from "../assets/defult/img/eggs/r/egg_r_19.png";
import r20png from "../assets/defult/img/eggs/r/egg_r_20.png";
import r21png from "../assets/defult/img/eggs/r/egg_r_21.png";
import r22png from "../assets/defult/img/eggs/r/egg_r_22.png";
import bgen from "../assets/defult/img/dialog_bgen.png";
import bg from "../assets/defult/img/dialog_bg.png";

export default {
  name: "LotteryHitEgg",
  props: {
    memberCount: {
      type: Number
    },
    userData: {},
    awardsList: {},
    propsMsg: '',
    propsMsg2: '',
    templateImage: '',
    code: '',
    lang: {
      type: String,
      default: 'zh-tw'
    }
  },
  watch: {

    templateImage(newData, oldData) {
      this.templateImage = newData
      console.log(this.lang)
      this.generateDynamicPrizes();
    },
  },
  data: () => ({
    eggb_ani: [
      b01png,
      b02png,
      b03png,
      b04png,
      b05png,
      b06png,
      b07png,
      b08png,
      b09png,
      b10png,
      b11png,
      b12png,
      b13png,
      b14png,
      b15png,
      b16png,
      b17png,
      b18png,
      b19png,
      b20png,
      b21png,
      b22png,
    ],
    eggg_ani: [
      g01png,
      g02png,
      g03png,
      g04png,
      g05png,
      g06png,
      g07png,
      g08png,
      g09png,
      g10png,
      g11png,
      g12png,
      g13png,
      g14png,
      g15png,
      g16png,
      g17png,
      g18png,
      g19png,
      g20png,
      g21png,
      g22png,
    ],
    eggr_ani: [
      r01png,
      r02png,
      r03png,
      r04png,
      r05png,
      r06png,
      r07png,
      r08png,
      r09png,
      r10png,
      r11png,
      r12png,
      r13png,
      r14png,
      r15png,
      r16png,
      r17png,
      r18png,
      r19png,
      r20png,
      r21png,
      r22png,
    ],
    breakEggImgList: [],
    eggShowType : 'b',
    showBreakEggAnimate: false,
    showModalTrigger: false,
    aniIndex: 0,
    fps: 66,
    backgroundUrl: `url(${bg})`,
    backgroundUrlen: `url(${bgen})`,
    defultCloseIcon: require("../assets/defult/img/closebtn.png"),
    defultWinningDialogButton: require('../assets/defult/img/dialog_btnzh-tw.png'),
    defultWinningDialog: `url(${bg})`,
    defultLotteryTitle: require('../assets/defult/img/egg_titlezh-tw.png')
  }),
  
  methods: {
    generateDynamicPrizes() {
      if (this.templateImage != '') {
        const json_image = JSON.parse(this.templateImage)
        console.log(json_image)
        for (const [key, value] of Object.entries(json_image)) {
          switch (key) {
            case "CloseIcon":
              this.defultCloseIcon = value
              break;
            case "WinningDialogButton":
              this.defultWinningDialogButton = value
              break;
            case "WinningDialog":
              this.defultWinningDialog = `url(${value})`
              break;
            case "LotteryTitle":
              this.defultLotteryTitle = value
              break;
            default:
              break;
          }
        }
      }

    },
    breakegg(type) {
      //如果次數為0 不得抽獎
      if (this.code != "0") {
        this.showModalTrigger = true
        this.msg = this.propsMsg
        this.msg2 = this.propsMsg2
      }else{
        if (this.memberCount === 0 || this.memberCount === null) {
          this.showModalTrigger = true
          this.msg = this.$t('turn.zero')
          this.msg2 = ""
          // 如果尚在抽獎中不執行任何動作
        } else {
          if (this.rolling) {
            this.showModalTrigger = true
            this.msg = this.$t('turn.drawing')
            this.msg2 = ""
            return;
          }
          this.getWinning(type)
        }
      }

    },
    async getWinning(type) {
      this.rolling = true;
      let postData = {
        Token: this.userData.token,
        PEid: this.userData.peid
      }
      await fetch('/api/drawEvents',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          if (res.code == "0") {
            this.roll(res.data, type);
          } else {
            this.showModalTrigger = true
            this.msg = this.$t('turn.' + res.data)
            this.msg2 = this.$t("turn.contact");
            this.rolling = false;
          }
        })
    },
    roll(result, type = 'b') {
      this.aniIndex = 0
      if (isNaN(result)) {
        let jresult = JSON.parse(result)
        let result_name = Object.keys(jresult)
        result = result_name[0]
      }
      this.eggShowType = type
      this.showBreakEggAnimate = true
      let animateFn = () => {
        if (this.aniIndex < this.eggb_ani.length - 1) {
          this.aniIndex++;
          setTimeout(() => {
            window.requestAnimationFrame(animateFn);
          }, this.fps);
        } else {
          cancelAnimationFrame(animateFn);
          setTimeout(() => {
            this.showBreakEggAnimate = false
            this.aniIndex = 0;
            this.showModalTrigger = true
            this.msg = this.$t('turn.congratulations');
            this.msg2 = this.awardsList[result]
            this.rolling = false;
            this.$emit('rollDone', 1);
          }, 1000)
        }
      }
      window.requestAnimationFrame(animateFn);
    },
    backHome() {
      this.$emit('closeDialog', false)
    }
  },
  mounted() {

  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/eggs_modal.vue